export enum InvoiceType {
    EngagementBuyerSelectionFee = 1,
    EngagementMonthlyRetainerFee = 2,
    EngagementDocumentAccess = 3,
    EngagementLateFee = 4,
    EngagementDeadlineExtensionFee = 5,
}
